// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Actions Imports
import { updateDocumentClickedComponentID } from "../../../actions/DocumentActions/index";

class CustomPageBreak extends Component {
  customPageBreakRef = React.createRef();

  componentDidMount() {
    if (
      this.customPageBreakRef &&
      this.customPageBreakRef.current &&
      this.props.isComponentActive
    ) {
      this.customPageBreakRef.current.focus();
    }
  }

  _handleOnClick = event => {
    event.preventDefault();
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive && section) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      this.props.createDocSectionRef(React.createRef());
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    const { isComponentActive, preventClickedComponentIdUpdate } = this.props;
    if (isComponentActive && preventClickedComponentIdUpdate) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    return (
      <div
        ref={this.customPageBreakRef}
        className={`custompagebreak-component ${
          this.props.isComponentActive ? "active-custompagebreak" : ""
        } `}
        onClick={this._handleOnClick}
        onKeyPress={() => {}}
        onBlur={this._handleOnBlur}
        role="button"
        tabIndex={0}>
        <span className="custompagebreak-text-wrapper">
          <span className="custompagebreak-text">Page Break</span>
        </span>
        <span className="custompagebreak-line" />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { section } = props;
  const {
    clickedActiveComponentId,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;
  let isComponentActive = false;
  if (clickedActiveComponentId === section.id) isComponentActive = true;
  return {
    isComponentActive,
    preventClickedComponentIdUpdate,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomPageBreak);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomPageBreak/index.js